module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-right-simple-090819a83befe463db2535d919793858.svg";